import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./index.tsx";
import reportWebVitals from "./reportWebVitals";

// Prerendered routes (scripts/prerender.js) ship real markup for crawlers and a fast
// first paint. We client-render rather than hydrate: the prerenderer captures a
// client-rendered DOM without SSR text-boundary markers, which hydrateRoot would flag
// as a mismatch. React replaces the prerendered markup with an identical render.
const container = document.getElementById("root");
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
